import "./toggle.css";

const ToggleTheme = ({ handleChange, isChecked }) => {
  return (
    <div className="toggle-container">
      <input
        type="checkbox"
        id="check"
        className="toggle"
        onChange={handleChange}
        checked={isChecked}
      />
      <label htmlFor="check" className="toggle-label">
        <span className="icon">{isChecked ? "🌙" : "☀️"}</span>
      </label>
    </div>
  );
};

export default ToggleTheme;
